import "../enums/accordion.js";
import "../enums/alert.js";
import "../enums/avatar.js";
import { Breakpoints } from "../enums/breakpoints.js";
import "../enums/button.js";
import "../enums/code-editor.js";
import "../enums/colors.js";
import "../enums/combobox.js";
import "../enums/date.js";
import "../enums/drag-and-drop.js";
import "../enums/dialog.js";
import "../enums/divider.js";
import "../enums/dropdown.js";
import "../enums/fieldset.js";
import "../enums/font-icon.js";
import "../enums/fonts.js";
import "../enums/headings.js";
import "../enums/input.js";
import "../enums/keys.js";
import "../enums/list.js";
import "../enums/listbox.js";
import "../enums/loader.js";
import "../enums/margin.js";
import "../enums/option.js";
import "../enums/pill.js";
import "../enums/placements.js";
import "../enums/popout.js";
import "../enums/privacy.js";
import "../enums/radio-group.js";
import "../enums/status.js";
import "../enums/switch.js";
import "../enums/table.js";
import "../enums/tooltip.js";
import "../enums/transitions.js";
import "../enums/widths.js";
import { useMatchMedia } from "./use-match-media.js";

/**
 * A React hook for returning matching breakpoints
 * @example const { isXxxSm, isXxSm, isXSm, isSm, isMd, isLg, isXl, isXxl, isXxxl } = useBreakpoints();
 * @returns UseBreakpoints
 */
var useBreakpoints = function useBreakpoints() {
  var isXxxSm = useMatchMedia("(min-width: ".concat(Breakpoints.XxxSm, "px)"));
  var isXxSm = useMatchMedia("(min-width: ".concat(Breakpoints.XxSm, "px)"));
  var isXSm = useMatchMedia("(min-width: ".concat(Breakpoints.XSm, "px)"));
  var isSm = useMatchMedia("(min-width: ".concat(Breakpoints.Sm, "px)"));
  var isMd = useMatchMedia("(min-width: ".concat(Breakpoints.Md, "px)"));
  var isLg = useMatchMedia("(min-width: ".concat(Breakpoints.Lg, "px)"));
  var isXl = useMatchMedia("(min-width: ".concat(Breakpoints.Xl, "px)"));
  var isXxl = useMatchMedia("(min-width: ".concat(Breakpoints.Xxl, "px)"));
  var isXxxl = useMatchMedia("(min-width: ".concat(Breakpoints.Xxxl, "px)"));
  return {
    isXxxSm: isXxxSm,
    isXxSm: isXxSm,
    isXSm: isXSm,
    isSm: isSm,
    isMd: isMd,
    isLg: isLg,
    isXl: isXl,
    isXxl: isXxl,
    isXxxl: isXxxl
  };
};
export { useBreakpoints };